import { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

require('./DateField.css');

export type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> & {
    id: string;
    value: number | null; // Override value because we want UtcTime | null to be provided
    required?: boolean;
    label?: string;
    labelKey?: string;
    error?: string;
};

export const DateField = ({ required, id, className, label, labelKey, value, disabled, error, ...otherProps }: Props) => {
    const { t } = useTranslation();
    return (
        <div className={ `${required ? 'required' : ''} field date-field ${className || ''}` }>
            { (label || labelKey) &&
                <label htmlFor={ id } className={ disabled ? 'disabled' : '' }>
                    { label || t(labelKey!) }
                </label>
            }
            <input
                id={ id }
                type="date"
                disabled={ disabled }
                value={ value ? new Date(value).toISOString().substring(0, 10) : '' }
                { ...otherProps }
            />
            { error &&
                <div className="error">
                    { error }
                </div>
            }
        </div>
    );
};
